import { inject, Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AppService } from '../services/app.service';

@Injectable({
    providedIn: 'root'
})
export class EmbeddedOnlyGuard {

    private readonly _appService = inject(AppService);
    private readonly _router = inject(Router);

    canActivate(): boolean | UrlTree {
        if (this._appService.isEmbeddedMode()) {
            return true;
        }
        return this._router.createUrlTree(['/cotacoes']);
    }
}
